<template>
  <div class="container-fluid principal">
    <div class="row">
      <div class="col-md-12">
        <Toast position="top-right" :baseZIndex="2222" />
        <div class="row">
          <div class="col-md-12">
            <Toolbar>
              <template #right>
                <div class="row">
                  <div class="col-md-12">
                    <Button
                      v-if="png_loaded"
                      label=""
                      icon="pi pi-save"
                      class="p-button-info p-mr-2"
                      @click="generatePng('FYYTD', 'FYYTD')"
                    />
                    <ProgressSpinner
                      v-else
                      style="width: 50px; height: 50px"
                      strokeWidth="8"
                      fill="#EEEEEE"
                      animationDuration=".5s"
                    />
                  </div>
                </div>
              </template>
            </Toolbar>
          </div>
          <div id="FYYTD" class="col-md-12">
            <Card>
              <!-- <template #title><h4>Accumulated operations</h4></template> -->
              <template #title
                ><h4><b>FYYTD</b></h4></template
              >
              <template #content>
                <br />
                <Chart
                  :height="400"
                  v-if="bar_chart_accumulated_operations_loaded"
                  ref="bar_chart_accumulated_operations"
                  type="bar"
                  :data="bar_chart_accumulated_operations_data"
                  :options="bar_chart_options"
                />
                <ProgressSpinner v-else />
                <br />
              </template>
              <template #footer
                ><div class="row">
                  <div class="col-md-5"></div>
                  <div class="col-md-4">
                    <Chip
                      :label="total_operations + ' Importaciones'"
                      icon="pi pi-exclamation-circle"
                      class="p-mr-2"
                    />
                  </div>
                </div>
              </template>
            </Card>
            <br />
          </div>
          <div class="col-md-12">
            <Toolbar>
              <template #left>
                <Dropdown
                  v-model="selected_year_forecast_fy_with_diff"
                  class="selected_year"
                  :options="years"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select a Year"
                  :filter="true"
                  emptyFilterMessage="Please enter a valid Year."
                  @change="selectedYearForecastFyWithDiff"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
              </template>
              <template #right>
                <div class="row">
                  <div class="col-md-12">
                    <Button
                      v-if="png_loaded"
                      label=""
                      icon="pi pi-save"
                      class="p-button-info p-mr-2"
                      @click="
                        generatePng(
                          'FORECASTFY',
                          'FORECAST FY' +
                            selected_year_forecast_fy_with_diff.substring(2, 4)
                        )
                      "
                    />
                    <ProgressSpinner
                      v-else
                      style="width: 50px; height: 50px"
                      strokeWidth="8"
                      fill="#EEEEEE"
                      animationDuration=".5s"
                    />
                  </div>
                </div>
              </template>
            </Toolbar>
          </div>
          <!-- <div class="col-md-12">
            <Card>
              <template #title>
                <h4>
                  <b>FORECAST FY{{ selected_year.substring(2, 4) }}</b>
                </h4>
              </template>
              <template #content>
                <br />
                <Chart
                  :height="400"
                  v-if="bar_chart_forecast_fy_loaded"
                  ref="bar_chart_forecast_fy"
                  type="bar"
                  :data="bar_chart_forecast_fy_data"
                  :options="bar_chart_forecast_fy_options"
                />
                <ProgressSpinner v-else />
                <br />
              </template>
              <template #footer> </template>
            </Card>
            <br />
          </div> -->
          <div id="FORECASTFY" class="col-md-12">
            <Card>
              <template #title>
                <!-- <h4> Forecast FY{{ selected_year }}</h4> -->
                <h4>
                  <b
                    >FORECAST FY{{
                      selected_year_forecast_fy_with_diff.substring(2, 4)
                    }}</b
                  >
                </h4>
                <div
                  v-if="bar_chart_forecast_fy_with_diff_loaded"
                  class="p-text-right"
                >
                  <Avatar
                    :label="''"
                    style="
                      background-color: #1061ed;
                      color: #ffffff;
                      width: 45px;
                      height: 15px;
                      font-weight: bold;
                    "
                  />
                  <span>
                    {{
                      "FY" + selected_year_forecast_fy_with_diff.substring(2, 4)
                    }} </span
                  ><br />
                  <Avatar
                    :label="''"
                    style="
                      background-color: #2b2c28;
                      color: #ffffff;
                      width: 45px;
                      height: 15px;
                      font-weight: bold;
                    "
                  />
                  <span>
                    {{
                      "FY" +
                      (parseInt(
                        selected_year_forecast_fy_with_diff.substring(2, 4)
                      ) -
                        1)
                    }}
                  </span>
                </div>
              </template>
              <template #content>
                <br />
                <Chart
                  :height="400"
                  v-if="bar_chart_forecast_fy_with_diff_loaded"
                  ref="bar_chart_forecast_fy_with_diff"
                  type="bar"
                  :data="bar_chart_forecast_fy_with_diff_data"
                  :options="bar_chart_forecast_fy_with_diff_options"
                />
                <ProgressSpinner v-else />
                <br />
              </template>
              <template #footer> </template>
            </Card>
            <br />
          </div>
          <div class="col-md-12">
            <Toolbar>
              <template #left>
                <Dropdown
                  v-model="selected_year_ttl_fy"
                  class="selected_year"
                  :options="years"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select a Year"
                  :filter="true"
                  emptyFilterMessage="Please enter a valid Year."
                  @change="selectedYearTtlFy"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
              </template>
              <template #right>
                <div class="row">
                  <div class="col-md-12">
                    <Button
                      v-if="png_loaded"
                      label=""
                      icon="pi pi-save"
                      class="p-button-info p-mr-2"
                      @click="
                        generatePng(
                          'TOTALFY',
                          'TOTAL FY' + selected_year_ttl_fy.substring(2, 4)
                        )
                      "
                    />
                    <ProgressSpinner
                      v-else
                      style="width: 50px; height: 50px"
                      strokeWidth="8"
                      fill="#EEEEEE"
                      animationDuration=".5s"
                    />
                  </div>
                </div>
              </template>
            </Toolbar>
          </div>
          <div id="TOTALFY" class="col-md-12">
            <Card>
              <template #title>
                <!-- <h4> TTL FY {{ selected_year }}</h4> -->
                <h4>
                  <b>TOTAL FY{{ selected_year_ttl_fy.substring(2, 4) }}</b>
                </h4>
              </template>
              <template #content>
                <br />
                <Chart
                  :height="400"
                  v-if="bar_chart_ttl_fy_operations_loaded"
                  ref="bar_chart_ttl_fy"
                  type="bar"
                  :data="bar_chart_ttl_fy_operations_data"
                  :options="bar_chart_ttl_fy_operations_options"
                />
                <ProgressSpinner v-else />
                <br />
              </template>
              <template #footer> </template>
            </Card>
            <br />
          </div>
          <div class="col-md-12">
            <Toolbar>
              <template #left>
                <Dropdown
                  v-model="selected_year_top_10_expats_fy"
                  class="selected_year"
                  :options="years"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select a Year"
                  :filter="true"
                  emptyFilterMessage="Please enter a valid Year."
                  @change="selectedYearTop10ExpatsFY"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
              </template>
              <template #right>
                <div class="row">
                  <div class="col-md-12">
                    <Button
                      v-if="png_loaded"
                      label=""
                      icon="pi pi-save"
                      class="p-button-info p-mr-2"
                      @click="
                        generatePng(
                          'TOPTENCLIENTSFY',
                          'TOPTEN CLIENTS FY' +
                            selected_year_top_10_expats_fy.substring(2, 4)
                        )
                      "
                    />
                    <ProgressSpinner
                      v-else
                      style="width: 50px; height: 50px"
                      strokeWidth="8"
                      fill="#EEEEEE"
                      animationDuration=".5s"
                    />
                  </div>
                </div>
              </template>
            </Toolbar>
          </div>
          <div id="TOPTENCLIENTSFY" class="col-md-12">
            <Card>
              <template #title>
                <!-- <h4>Top 10 Expats FY{{ selected_year }}</h4> -->
                <h4>
                  <b
                    >TOPTEN CLIENTS FY{{
                      selected_year_top_10_expats_fy.substring(2, 4)
                    }}</b
                  >
                </h4>
              </template>
              <template #content>
                <br />
                <Chart
                  :height="500"
                  v-if="pie_chart_top_10_expats_fy_loaded"
                  ref="pie_chart_top_10_expats_fy"
                  type="pie"
                  :data="pie_chart_top_10_expats_fy_data"
                  :options="pie_chart_top_10_expats_fy_options"
                />
                <ProgressSpinner v-else />
                <br />
              </template>
              <template #footer> </template>
            </Card>
            <br />
          </div>
          <!-- <div class="col-md-12">
            <Card>
              <template #title
                >Imports made during
                {{ selected_year }}
              </template>
              <template #content>
                <br />
                <Chart
                  :height="400"
                  v-if="line_chart_year_by_month_loaded"
                  ref="line_year_by_month_chart"
                  type="line"
                  :data="line_year_by_month_chart_data"
                  :options="line_chart_options"
                />

                <ProgressSpinner v-else />
                <br />
              </template>
              <template #footer> </template>
            </Card>
            <br />
          </div> -->
          <!-- <div class="col-md-12">
            <Card>
              <template #title>
                Imports made during
                {{ formated_selected_monthly_to_display }}
              </template>
              <template #content>
                <br />
                <Chart
                  :height="400"
                  v-if="bar_month_chart_loaded"
                  ref="bar_month_chart"
                  type="bar"
                  :data="bar_month_chart_data"
                  :options="bar_chart_options"
                />
                <ProgressSpinner v-else />
                <br />
              </template>
              <template #footer> </template>
            </Card>
            <br />
          </div>
          <div class="col-md-12">
            <Card>
              <template #title>
                Imports made during
                {{ formated_selected_monthly_to_display }}
              </template>
              <template #content>
                <br />
                <Chart
                  :height="400"
                  v-if="bar_month_chart_loaded"
                  ref="bar_month_chart"
                  type="bar"
                  :data="bar_month_chart_data"
                  :options="bar_chart_options"
                />
                <ProgressSpinner v-else />
                <br />
              </template>
              <template #footer> </template>
            </Card>
            <br />
          </div> -->
          <div class="col-md-6">
            <div id="FYYTDPIE" class="col-md-12">
              <Toolbar>
                <template #left>
                  <!-- <label for="selected_monthly">Select the Month: </label> -->
                  <Calendar
                    id="selected_monthly"
                    class="selected_monthly"
                    v-model="selected_monthly"
                    view="month"
                    dateFormat="mm-yy"
                    @date-select="selectMonthly"
                    :manualInput="false"
                    :showIcon="true"
                  />
                </template>
                <template #right>
                  <div class="row">
                    <div class="col-md-12">
                      <Button
                        v-if="png_loaded"
                        label=""
                        icon="pi pi-save"
                        class="p-button-info p-mr-2"
                        @click="
                          generatePng(
                            'FYYTDPIE',
                            'FY' +
                              formated_selected_monthly_to_display.substring(
                                2,
                                4
                              ) +
                              'YTD'
                          )
                        "
                      />
                      <ProgressSpinner
                        v-else
                        style="width: 50px; height: 50px"
                        strokeWidth="8"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                      />
                    </div>
                  </div>
                </template>
              </Toolbar>
              <Card>
                <template #title>
                  <!-- <h4> Imports made during{{ formated_selected_monthly_to_display }}</h4> -->
                  <h4>
                    <b>
                      FY{{
                        formated_selected_monthly_to_display.substring(2, 4)
                      }}YTD</b
                    >
                  </h4>
                </template>
                <template #content>
                  <br />
                  <div
                    v-if="pie_chart_operations_by_month_loaded"
                    class="pie-chart-wrapper"
                  >
                    <div class="pie-chart-canvas">
                      <Chart
                        :height="500"
                        ref="pie_chart_operations_by_month"
                        type="pie"
                        :data="pie_chart_operations_by_month_data"
                        :options="pie_chart_operations_by_month_options"
                      />
                    </div>
                    <div class="pie-chart-legend">
                      <ul class="pie-chart-legend-list">
                        <li
                          v-for="(label, index) in pie_chart_operations_by_month_data.labels"
                          :key="'legend1-' + index"
                          class="pie-chart-legend-item"
                          :class="{ 'pie-chart-legend-item--hidden': isPieHidden(1, index) }"
                          @click="togglePieDataset(1, index)"
                        >
                          <span
                            class="pie-chart-legend-color"
                            :style="{
                              backgroundColor: isPieHidden(1, index)
                                ? '#d3d3d3'
                                : pie_chart_operations_by_month_data.datasets[0].backgroundColor[index]
                            }"
                          ></span>
                          <span class="pie-chart-legend-label">{{ label }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ProgressSpinner v-else />
                  <br />
                </template>
                <template #footer> </template>
              </Card>
              <br />
            </div>
          </div>
          <div class="col-md-6">
            <div id="FYYTDPIE2" class="col-md-12">
              <Toolbar>
                <template #left>
                  <!-- <label for="selected_monthly">Select the Month: </label> -->
                  <Calendar
                    id="selected_monthly2"
                    class="selected_monthly2"
                    v-model="selected_monthly2"
                    view="month"
                    dateFormat="mm-yy"
                    @date-select="selectMonthly2"
                    :manualInput="false"
                    :showIcon="true"
                  />
                </template>
                <template #right>
                  <div class="row">
                    <div class="col-md-12">
                      <Button
                        v-if="png_loaded"
                        label=""
                        icon="pi pi-save"
                        class="p-button-info p-mr-2"
                        @click="
                          generatePng(
                            'FYYTDPIE2',
                            'FY' +
                              formated_selected_monthly_to_display2.substring(
                                2,
                                4
                              ) +
                              'YTD'
                          )
                        "
                      />
                      <ProgressSpinner
                        v-else
                        style="width: 50px; height: 50px"
                        strokeWidth="8"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                      />
                    </div>
                  </div>
                </template>
              </Toolbar>
              <Card>
                <template #title>
                  <!-- <h4> Imports made during{{ formated_selected_monthly_to_display }}</h4> -->
                  <h4>
                    <b>
                      FY{{
                        formated_selected_monthly_to_display2.substring(2, 4)
                      }}YTD</b
                    >
                  </h4>
                </template>
                <template #content>
                  <br />
                  <div
                    v-if="pie_chart_operations_by_month_loaded2"
                    class="pie-chart-wrapper"
                  >
                    <div class="pie-chart-canvas">
                      <Chart
                        :height="500"
                        ref="pie_chart_operations_by_month2"
                        type="pie"
                        :data="pie_chart_operations_by_month_data2"
                        :options="pie_chart_operations_by_month_options2"
                      />
                    </div>
                    <div class="pie-chart-legend">
                      <ul class="pie-chart-legend-list">
                        <li
                          v-for="(label, index) in pie_chart_operations_by_month_data2.labels"
                          :key="'legend2-' + index"
                          class="pie-chart-legend-item"
                          :class="{ 'pie-chart-legend-item--hidden': isPieHidden(2, index) }"
                          @click="togglePieDataset(2, index)"
                        >
                          <span
                            class="pie-chart-legend-color"
                            :style="{
                              backgroundColor: isPieHidden(2, index)
                                ? '#d3d3d3'
                                : pie_chart_operations_by_month_data2.datasets[0].backgroundColor[index]
                            }"
                          ></span>
                          <span class="pie-chart-legend-label">{{ label }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ProgressSpinner v-else />
                  <br />
                </template>
                <template #footer> </template>
              </Card>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import Toast from "primevue/toast";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import RadioButton from "primevue/radiobutton";
import InputNumber from "primevue/inputnumber";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Textarea from "primevue/textarea";
import Avatar from "primevue/avatar";
import Tag from "primevue/tag";
import Dropdown from "primevue/dropdown";
import ProgressSpinner from "primevue/progressspinner";
import InputSwitch from "primevue/inputswitch";
import Checkbox from "primevue/checkbox";
import Chart from "primevue/chart";
import Chip from "primevue/chip";
import Card from "primevue/card";
import Calendar from "primevue/calendar";
import "chartjs-plugin-datalabels";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
export default {
  name: "login-page",
  bodyClass: "login-page",

  data() {
    return {
      total_operations: 0,
      years: [
        { value: "2019", label: "2019" },
        { value: "2020", label: "2020" },
        { value: "2021", label: "2021" },
        { value: "2022", label: "2022" },
        { value: "2023", label: "2023" },
        { value: "2024", label: "2024" },
        { value: "2025", label: "2025" },
        { value: "2026", label: "2026" },
        { value: "2027", label: "2027" },
        { value: "2028", label: "2028" },
        { value: "2029", label: "2029" },
        { value: "2030", label: "2030" },
        { value: "2031", label: "2031" },
        { value: "2032", label: "2032" },
        { value: "2033", label: "2033" },
        { value: "2034", label: "2034" },
        { value: "2035", label: "2035" },
        { value: "2036", label: "2036" },
        { value: "2037", label: "2037" },
        { value: "2038", label: "2038" },
        { value: "2039", label: "2039" },
        { value: "2040", label: "2040" },
        { value: "2041", label: "2041" },
        { value: "2042", label: "2042" },
        { value: "2043", label: "2043" },
        { value: "2044", label: "2044" },
        { value: "2045", label: "2045" },
        { value: "2046", label: "2046" },
        { value: "2047", label: "2047" },
        { value: "2048", label: "2048" },
        { value: "2049", label: "2049" },
        { value: "2050", label: "2050" },
        { value: "2051", label: "2051" },
        { value: "2052", label: "2052" },
        { value: "2053", label: "2053" },
        { value: "2054", label: "2054" },
        { value: "2055", label: "2055" },
        { value: "2056", label: "2056" },
        { value: "2057", label: "2057" },
        { value: "2058", label: "2058" },
        { value: "2059", label: "2059" },
        { value: "2060", label: "2060" },
        { value: "2061", label: "2061" },
        { value: "2062", label: "2062" },
        { value: "2063", label: "2063" },
        { value: "2064", label: "2064" },
        { value: "2065", label: "2065" },
        { value: "2066", label: "2066" },
        { value: "2067", label: "2067" },
        { value: "2068", label: "2068" },
        { value: "2069", label: "2069" },
        { value: "2070", label: "2070" },
        { value: "2071", label: "2071" },
        { value: "2072", label: "2072" },
        { value: "2073", label: "2073" },
        { value: "2074", label: "2074" },
        { value: "2075", label: "2075" },
        { value: "2076", label: "2076" },
        { value: "2077", label: "2077" },
        { value: "2078", label: "2078" },
        { value: "2079", label: "2079" },
        { value: "2080", label: "2080" },
        { value: "2081", label: "2081" },
        { value: "2082", label: "2082" },
        { value: "2083", label: "2083" },
        { value: "2084", label: "2084" },
        { value: "2085", label: "2085" },
        { value: "2086", label: "2086" },
        { value: "2087", label: "2087" },
        { value: "2088", label: "2088" },
        { value: "2089", label: "2089" },
        { value: "2090", label: "2090" },
        { value: "2091", label: "2091" },
        { value: "2092", label: "2092" },
        { value: "2093", label: "2093" },
        { value: "2094", label: "2094" },
        { value: "2095", label: "2095" },
        { value: "2096", label: "2096" },
        { value: "2097", label: "2097" },
        { value: "2098", label: "2098" },
        { value: "2099", label: "2099" },
        { value: "2100", label: "2100" },
      ],
      selected_year: "",
      selected_year_ttl_fy: "",
      selected_year_top_10_expats_fy: "",
      selected_year_forecast_fy_with_diff: "",
      line_month_chart_loaded: false,
      bar_month_chart_loaded: false,
      line_chart_year_loaded: false,
      bar_chart_ttl_fy_operations_loaded: false,
      bar_chart_forecast_fy_loaded: false,
      bar_chart_forecast_fy_with_diff_loaded: false,
      pie_chart_top_10_expats_fy_loaded: false,
      line_chart_year_by_month_loaded: false,
      bar_chart_year_by_month_loaded: false,
      bar_chart_accumulated_operations_loaded: false,
      pie_chart_operations_by_month_loaded: false,
      pie_chart_operations_by_month_loaded2: false,
      selected_monthly: new Date(),
      selected_monthly2: new Date(),
      formated_selected_monthly: "",
      formated_selected_monthly_to_display: "",
      formated_selected_monthly2: "",
      formated_selected_monthly_to_display2: "",
      line_month_chart_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      bar_month_chart_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      line_year_chart_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      bar_chart_ttl_fy_operations_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      bar_chart_forecast_fy_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      bar_chart_forecast_fy_with_diff_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      pie_chart_top_10_expats_fy_data: {
        labels: ["No Data"],
        datasets: [
          {
            data: [0],
            backgroundColor: ["#42A5F5"],
          },
        ],
      },
      line_year_by_month_chart_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      bar_year_by_month_chart_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      bar_chart_accumulated_operations_data: {
        labels: [],
        datasets: [
          {
            label: "No Data",
            data: [],
            fill: false,
            borderColor: "#42A5F5",
          },
        ],
      },
      pie_chart_operations_by_month_data: {
        labels: ["No Data"],
        datasets: [
          {
            data: [0],
            backgroundColor: ["#42A5F5"],
          },
        ],
      },
      pie_chart_operations_by_month_data2: {
        labels: ["No Data"],
        datasets: [
          {
            data: [0],
            backgroundColor: ["#42A5F5"],
          },
        ],
      },
      pie_hidden_indices_1: [],
      pie_hidden_indices_2: [],
      pie_chart_operations_by_month_options: {
        maintainAspectRatio: false,
        aspectRatio: 3 / 2,
        cutoutPercentage: 8,
        layout: {
          padding: 25,
        },
        elements: {
          line: {
            fill: false,
          },
          point: {
            hoverRadius: 7,
            radius: 5,
          },
        },
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: "",
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return (
                data.labels[tooltipItems.index] +
                ": " +
                data.datasets[tooltipItems.datasetIndex].data[
                  tooltipItems.index
                ]
              );
            },
          },
        },
        plugins: {
          datalabels: {
            display: "auto",
            color: function (context) {
              return context.dataset.backgroundColor;
              // return "#ffffff";
            },
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 12 : 14,
                weight: "bold",
              };
            },
          },
        },
      },
      pie_chart_operations_by_month_options2: {
        maintainAspectRatio: false,
        aspectRatio: 3 / 2,
        cutoutPercentage: 8,
        layout: {
          padding: 25,
        },
        elements: {
          line: {
            fill: false,
          },
          point: {
            hoverRadius: 7,
            radius: 5,
          },
        },
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: "",
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return (
                data.labels[tooltipItems.index] +
                ": " +
                data.datasets[tooltipItems.datasetIndex].data[
                  tooltipItems.index
                ]
              );
            },
          },
        },
        plugins: {
          datalabels: {
            display: "auto",
            color: function (context) {
              return context.dataset.backgroundColor;
              // return "#ffffff";
            },
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 12 : 14,
                weight: "bold",
              };
            },
          },
        },
      },
      bar_chart_ttl_fy_operations_options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawOnChartArea: false,
                display: true,
                drawBorder: true,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              // gridLines: {
              //   drawOnChartArea: false,
              //   display: true,
              //   drawBorder: true,
              // },
              display: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          // onHover: function (event, legendItem) {},
          // onLeave: function (event, legendItem) {},
          // onClick: function (event, legendItem) {},
          position: "bottom",
          display: true,
          labels: {
            fontSize: 13,
          },
        },
        title: {
          display: true,
          text: "",
        },
        tooltips: {
          mode: "index",
          intersect: true,
          // callbacks: {
          //   label: function (tooltipItems, data) {
          //     return (
          //       "Importaciones: " + parseFloat(tooltipItems.value).toFixed(0)
          //     );
          //   },
          // },
        },
        plugins: {
          datalabels: {
            align: "end",
            anchor: "end",
            color: function (context) {
              return context.dataset.backgroundColor;
              // return "#ffffff";
            },
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 12 : 14,
                weight: "bold",
              };
            },
            formatter: function (value, context) {
              if (value.toFixed(0) == 0) {
                return "";
              } else {
                return value.toFixed(0);
              }
            },
          },
        },
      },
      bar_chart_forecast_fy_options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawOnChartArea: false,
                display: true,
                drawBorder: true,
              },
            },
          ],
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: true,
              },
            },
            {
              id: "bar-stacked",
              stacked: true,
              // gridLines: {
              //   drawOnChartArea: false,
              //   display: true,
              //   drawBorder: true,
              // },
              display: false,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          // onHover: function (event, legendItem) {},
          // onLeave: function (event, legendItem) {},
          // onClick: function (event, legendItem) {},
          position: "bottom",
          labels: {
            fontSize: 13,
          },
        },
        title: {
          display: true,
          text: "",
        },
        tooltips: {
          mode: "index",
          intersect: true,
          // callbacks: {
          //   label: function (tooltipItems, data) {

          //     console.log(tooltipItems.value)
          //     console.log(data)
          //     return (
          //       "Importaciones: " + parseFloat(tooltipItems.value).toFixed(0)
          //     );
          //   },
          // },
        },
        plugins: {
          datalabels: {
            // display: "auto",
            align: "center",
            anchor: "center",
            color: function (context) {
              // return context.dataset.backgroundColor;
              if (context.datasetIndex == 0 || context.datasetIndex == 1) {
                return "#ffffff00";
              }
              return "#000501";
            },
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 12 : 14,
                weight: "bold",
              };
            },
            formatter: function (value, context) {
              // console.log(context);
              if (value.toFixed(0) == 0) {
                return "";
              }
              return value.toFixed(0);
            },
          },
        },
      },
      bar_chart_forecast_fy_with_diff_options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawOnChartArea: false,
                display: true,
                drawBorder: true,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              display: true,
              ticks: {
                beginAtZero: true,
              },
            },
            {
              id: "line_without_stack",
              stacked: false,
              // gridLines: {
              //   drawOnChartArea: false,
              //   display: false,
              //   drawBorder: true,
              // },
              display: false,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          // onHover: function (event, legendItem) {},
          // onLeave: function (event, legendItem) {},
          // onClick: function (event, legendItem) {},
          position: "bottom",
          labels: {
            fontSize: 13,
            filter: function (item, chart) {
              // Logic to remove a particular legend item goes here
              // console.log(item.text.length)
              return item.text.length > 0;
            },
          },
        },
        title: {
          display: true,
          text: "",
        },
        tooltips: {
          mode: "index",
          intersect: true,
          callbacks: {
            label: function (tooltipItems, data) {
              // tooltipItems.datasetIndex
              // tooltipItems.index
              let fiscal_year = tooltipItems.label.split(" ")[1];
              if (
                data.datasets[tooltipItems.datasetIndex].label.length > 0 &&
                data.datasets[tooltipItems.datasetIndex].label.includes(
                  fiscal_year
                )
              ) {
                return (
                  data.datasets[tooltipItems.datasetIndex].label +
                  ": " +
                  parseFloat(tooltipItems.value).toFixed(0)
                );
              }
            },
          },
        },
        plugins: {
          datalabels: {
            // display: "auto",
            align: "center",
            anchor: "center",
            color: function (context) {
              // return context.dataset.backgroundColor;
              if (context.datasetIndex == 0) {
                return "#ffffff00";
              }
              return "#000501";
            },
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 10 : 12,
                weight: "bold",
              };
            },
            formatter: function (value, context) {
              if (value.toFixed(0) == 0 || context.dataset.label.length == 0) {
                return "";
              }
              return value.toFixed(0);
            },
          },
        },
      },
      pie_chart_top_10_expats_fy_options: {
        maintainAspectRatio: false,
        aspectRatio: 3 / 2,
        cutoutPercentage: 8,
        layout: {
          padding: 25,
        },
        elements: {
          line: {
            fill: false,
          },
          point: {
            hoverRadius: 7,
            radius: 5,
          },
        },
        legend: {
          position: "right",
          labels: {
            padding: 15,
            fontSize: 13,

            // generateLabels: (chart) => {
            //   // chart.legend.afterFit = function () {
            //   //   this.height = this.height + 50;
            //   // };
            //   var data = chart.data;
            //   if (data.labels.length && data.datasets.length) {
            //     return data.labels.map((label, i) => {
            //       var label_splited = label.split(";")
            //       var label_data = label_splited[1]
            //       return {
            //         text: label,
            //         index: i,
            //         fillStyle: data.datasets[0].backgroundColor[i],
            //         lineWidth: 1,
            //         strokeStyle: data.datasets[0].backgroundColor[i],
            //       };
            //     });
            //   }
            //   return [];
            // },
          },
        },
        title: {
          display: true,
          text: "",
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return (
                data.labels[tooltipItems.index] +
                ": " +
                data.datasets[tooltipItems.datasetIndex].data[
                  tooltipItems.index
                ]
              );
            },
          },
        },
        plugins: {
          datalabels: {
            display: "auto",
            color: function (context) {
              return context.dataset.backgroundColor;
              // return "#ffffff";
            },
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 12 : 14,
                weight: "bold",
              };
            },
          },
        },
      },
      bar_chart_options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
                display: true,
                drawBorder: true,
              },
            },
          ],
          yAxes: [
            {
              // gridLines: {
              //   drawOnChartArea: false,
              //   display: true,
              //   drawBorder: true,
              // },
              display: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          onHover: function (event, legendItem) {},
          onLeave: function (event, legendItem) {},
          onClick: function (event, legendItem) {},
          position: "bottom",
          labels: {
            fontSize: 13,
          },
        },
        title: {
          display: true,
          text: "",
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return (
                "Importaciones: " + parseFloat(tooltipItems.value).toFixed(0)
              );
            },
          },
        },
        plugins: {
          datalabels: {
            align: "end",
            anchor: "end",
            color: function (context) {
              return context.dataset.backgroundColor;
              // return "#ffffff";
            },
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 12 : 14,
                weight: "bold",
              };
            },
            formatter: function (value, context) {
              return value.toFixed(0);
            },
          },
        },
      },
      line_chart_options: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
                display: true,
                drawBorder: true,
              },
            },
          ],
          yAxes: [
            {
              // gridLines: {
              //   drawOnChartArea: false,
              //   display: true,
              //   drawBorder: true,
              // },
              display: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          onHover: function (event, legendItem) {},
          onLeave: function (event, legendItem) {},
          onClick: function (event, legendItem) {},
          position: "bottom",
          labels: {
            fontSize: 13,
          },
        },
        title: {
          display: true,
          text: "",
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              // return (
              //   tooltipItems.label +
              //   ": " +
              //   parseFloat(tooltipItems.value).toFixed(0)
              // );
              return (
                "Importaciones: " + parseFloat(tooltipItems.value).toFixed(0)
              );
            },
          },
        },
        plugins: {
          datalabels: {
            display: function (context) {
              return true;
            },
            align: "end",
            anchor: "end",
            color: function (context) {
              return context.dataset.borderColor;
            },
            font: function (context) {
              var w = context.chart.width;
              return {
                size: w < 512 ? 12 : 14,
                weight: "bold",
              };
            },
            formatter: function (value, context) {
              return value.toFixed(0);
            },
          },
        },
      },
      png_loaded: true,
    };
  },
  async created() {
    moment.locale("en");
    var date = new Date();
    if (date.getMonth() < 3) {
      date.setFullYear(date.getFullYear() - 1);
    }
    this.selected_year = moment(date).format("YYYY");
    this.selected_year_ttl_fy = moment(date).format("YYYY");
    this.selected_year_top_10_expats_fy = moment(date).format("YYYY");
    this.selected_year_forecast_fy_with_diff = moment(date).format("YYYY");
    this.formated_selected_monthly = moment(this.selected_monthly).format(
      "MM-YYYY"
    );
    this.formated_selected_monthly2 = moment(this.selected_monthly2).format(
      "MM-YYYY"
    );
    // this.formated_selected_monthly_to_display = moment(
    //   this.selected_monthly
    // ).format("MMMM YYYY");
    this.formated_selected_monthly_to_display = moment(
      date
    ).format("YYYY");
    this.getOperationYearLineChart();
    this.getOperationYearByMonthLineChart();
    this.getOperationYearByMonthBarChart();
    this.getOperationAccumulatedBarChart();
    this.getOperationTTLFYBarChart();
    this.getOperationForecastFYBarChart();
    this.getOperationForecastFYWithDiffBarChart();
    this.getOperationTop10ExpatsFYPieChart();
    this.getOperationMonthPieChart();
    this.getOperationMonthPieChart2();
  },
  mounted() {},
  methods: {
    generatePng(id_html, filename) {
      let options = {
        scale: 2,
        scrollY: -window.scrollY,
      };
      html2canvas(document.querySelector("#" + id_html), options).then(
        (canvas) => {
          var canvas_image = canvas.toDataURL();
          this.saveAs(canvas_image, filename + ".png");

          // var canvas_image = canvas.toDataURL();
          // console.log(canvas_image);
          // const img = new Image();

          // img.src = canvas_image;
          // img.onload = () => {
          //   const imgWidth = img.naturalWidth;
          //   const imgHeight = img.naturalHeight;

          //   console.log("imgWidth: ", imgWidth);
          //   console.log("imgHeight: ", imgHeight);
          //   let x = imgWidth / 793;
          //   let width_image = imgWidth / x;
          //   let heigth_image = imgHeight / x;
          //   var pdf = new jsPDF("p", "pt", [793.700787402, 1122.519685039]);
          //   pdf.addImage(canvas_image, 0, 0, width_image, heigth_image);
          //   // download the pdf
          //   pdf.save(filename + ".pdf");
          // };
        }
      );
    },
    saveAs(uri, filename) {
      var link = document.createElement("a");

      if (typeof link.download === "string") {
        link.href = uri;
        link.download = filename;

        //Firefox requires the link to be in the body
        document.body.appendChild(link);

        //simulate click
        link.click();

        //remove the link when done
        document.body.removeChild(link);
      } else {
        window.open(uri);
      }
    },
    selectedYear() {
      this.getOperationYearLineChart();
      this.getOperationYearByMonthLineChart();
      this.getOperationYearByMonthBarChart();
      this.getOperationTTLFYBarChart();
      this.getOperationForecastFYBarChart();
      this.getOperationForecastFYWithDiffBarChart();
      this.getOperationTop10ExpatsFYPieChart();
    },
    selectedYearForecastFyWithDiff() {
      this.getOperationForecastFYWithDiffBarChart();
    },
    selectedYearTtlFy() {
      this.getOperationTTLFYBarChart();
    },
    selectedYearTop10ExpatsFY() {
      this.getOperationTop10ExpatsFYPieChart();
    },
    getToken() {
      let token = localStorage.getItem("idToken");
      return token;
    },
    getOperationYearLineChart() {
      this.line_chart_year_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&operation_ata=${this.selected_year}&group_by=company_id&chart_type=line`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.line_chart_year_loaded = true;
          this.line_year_chart_data = res.data;
          this.$refs.line_year_chart.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.line_chart_year_loaded = true;
        });
    },
    getOperationYearByMonthLineChart() {
      this.line_chart_year_by_month_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&operation_ata=${this.selected_year}&group_by=operation_ata&chart_type=line`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.line_chart_year_by_month_loaded = true;
          this.line_year_by_month_chart_data = res.data;
          this.$refs.line_year_by_month_chart.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.line_chart_year_by_month_loaded = true;
        });
    },
    getOperationAccumulatedBarChart() {
      this.bar_chart_accumulated_operations_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&chart_category=accumulated_operations`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          let total = 0;
          res.data.datasets[0].data.forEach((element) => {
            total += element;
          });
          this.total_operations = total;
          this.bar_chart_accumulated_operations_loaded = true;
          this.bar_chart_accumulated_operations_data = res.data;
          this.$refs.bar_chart_accumulated_operations.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.bar_chart_accumulated_operations_loaded = true;
        });
    },
    getOperationTop10ExpatsFYPieChart() {
      this.pie_chart_top_10_expats_fy_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&chart_category=top_10_expats_fy&fiscal_year=${this.selected_year_top_10_expats_fy}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);

          this.pie_chart_top_10_expats_fy_loaded = true;
          this.pie_chart_top_10_expats_fy_data = res.data;
          this.pie_chart_top_10_expats_fy_data["datasets"][0]["datalabels"] = {
            labels: {
              percentage: {
                align: "end",
                anchor: "end",
                // clip: true,
                color: function (ctx) {
                  return ctx.dataset.backgroundColor;
                },
                formatter: function (value, context) {
                  let total = 0;
                  context.dataset.data.forEach((data) => {
                    total += data;
                  });
                  let percentage = (value * 100) / total;
                  let label_splited =
                    context.chart.data.labels[context.dataIndex].split(";");
                  // return (
                  //   context.chart.data.labels[context.dataIndex] +
                  //   ": " +
                  //   percentage.toFixed(1) +
                  //   " %"
                  // );
                  // return label_splited[0] + ": " + percentage.toFixed(1) + " %";
                  return percentage.toFixed(1) + " %";
                },
              },
              // name: {
              //   align: "top",
              //   formatter: function (value, ctx) {
              //     return ctx.chart.data.labels[ctx.dataIndex];
              //   },
              //   color: function (ctx) {
              //     return "white";
              //   },
              // },
              value: {
                align: "center",
                color: function (ctx) {
                  return "white";
                },
                formatter: function (value, ctx) {
                  return value;
                },
              },
            },
          };
          this.$refs.pie_chart_top_10_expats_fy.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.pie_chart_top_10_expats_fy_loaded = true;
        });
    },
    getOperationForecastFYBarChart() {
      this.bar_chart_forecast_fy_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&chart_category=forecast_fy&fiscal_year=${this.selected_year}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.bar_chart_forecast_fy_loaded = true;
          this.bar_chart_forecast_fy_data = res.data;
          this.$refs.bar_chart_forecast_fy.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.bar_chart_forecast_fy_loaded = true;
        });
    },
    getOperationForecastFYWithDiffBarChart() {
      this.bar_chart_forecast_fy_with_diff_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&chart_category=forecast_fy_with_diff&fiscal_year=${this.selected_year_forecast_fy_with_diff}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.bar_chart_forecast_fy_with_diff_loaded = true;
          this.bar_chart_forecast_fy_with_diff_data = res.data;
          this.$refs.bar_chart_forecast_fy_with_diff.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.bar_chart_forecast_fy_with_diff_loaded = true;
        });
    },
    getOperationTTLFYBarChart() {
      this.bar_chart_ttl_fy_operations_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&chart_category=ttl_fy_operations&fiscal_year=${this.selected_year_ttl_fy}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);

          this.bar_chart_ttl_fy_operations_loaded = true;
          this.bar_chart_ttl_fy_operations_data = res.data;
          this.$refs.bar_chart_ttl_fy_operations.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.bar_chart_ttl_fy_operations_loaded = true;
        });
    },
    togglePieDataset(chartNum, index) {
      const refName =
        chartNum === 1
          ? "pie_chart_operations_by_month"
          : "pie_chart_operations_by_month2";
      const hiddenKey =
        chartNum === 1 ? "pie_hidden_indices_1" : "pie_hidden_indices_2";

      const chartInstance = this.$refs[refName].chart;
      if (!chartInstance) return;

      const meta = chartInstance.getDatasetMeta(0);
      const item = meta.data[index];

      if (item.hidden === null || item.hidden === false) {
        item.hidden = true;
        if (!this[hiddenKey].includes(index)) {
          this[hiddenKey].push(index);
        }
      } else {
        item.hidden = false;
        this[hiddenKey] = this[hiddenKey].filter((i) => i !== index);
      }

      chartInstance.update();
    },
    isPieHidden(chartNum, index) {
      const hiddenKey =
        chartNum === 1 ? "pie_hidden_indices_1" : "pie_hidden_indices_2";
      return this[hiddenKey].includes(index);
    },
    getOperationMonthPieChart() {
      this.pie_chart_operations_by_month_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&chart_category=pie_operations_by_month&month_period=${this.formated_selected_monthly}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.pie_chart_operations_by_month_loaded = true;
          this.pie_chart_operations_by_month_data = res.data;
          this.pie_hidden_indices_1 = [];
          this.pie_chart_operations_by_month_data["datasets"][0]["datalabels"] =
            {
              labels: {
                percentage: {
                  align: "end",
                  anchor: "end",
                  // clip: true,
                  color: function (ctx) {
                    return ctx.dataset.backgroundColor;
                  },
                  formatter: function (value, context) {
                    let total = 0;
                    context.dataset.data.forEach((data) => {
                      total += data;
                    });
                    let percentage = (value * 100) / total;
                    // return (
                    //   context.chart.data.labels[context.dataIndex] +
                    //   ": " +
                    //   percentage.toFixed(1) +
                    //   " %"
                    // );
                    return percentage.toFixed(1) + " %";
                  },
                },
                // name: {
                //   align: "top",
                //   formatter: function (value, ctx) {
                //     return ctx.chart.data.labels[ctx.dataIndex];
                //   },
                //   color: function (ctx) {
                //     return "white";
                //   },
                // },
                value: {
                  align: "center",
                  color: function (ctx) {
                    return "white";
                  },
                  formatter: function (value, ctx) {
                    return value;
                  },
                },
              },
            };
          this.$refs.pie_chart_operations_by_month.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.pie_chart_operations_by_month_loaded = true;
        });
    },
    getOperationMonthPieChart2() {
      this.pie_chart_operations_by_month_loaded2 = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&chart_category=pie_operations_by_month&month_period=${this.formated_selected_monthly2}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.pie_chart_operations_by_month_loaded2 = true;
          this.pie_chart_operations_by_month_data2 = res.data;
          this.pie_hidden_indices_2 = [];
          this.pie_chart_operations_by_month_data2["datasets"][0][
            "datalabels"
          ] = {
            labels: {
              percentage: {
                align: "end",
                anchor: "end",
                // clip: true,
                color: function (ctx) {
                  return ctx.dataset.backgroundColor;
                },
                formatter: function (value, context) {
                  let total = 0;
                  context.dataset.data.forEach((data) => {
                    total += data;
                  });
                  let percentage = (value * 100) / total;
                  // return (
                  //   context.chart.data.labels[context.dataIndex] +
                  //   ": " +
                  //   percentage.toFixed(1) +
                  //   " %"
                  // );
                  return percentage.toFixed(1) + " %";
                },
              },
              // name: {
              //   align: "top",
              //   formatter: function (value, ctx) {
              //     return ctx.chart.data.labels[ctx.dataIndex];
              //   },
              //   color: function (ctx) {
              //     return "white";
              //   },
              // },
              value: {
                align: "center",
                color: function (ctx) {
                  return "white";
                },
                formatter: function (value, ctx) {
                  return value;
                },
              },
            },
          };
          this.$refs.pie_chart_operations_by_month2.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.pie_chart_operations_by_month_loaded2 = true;
        });
    },
    getOperationYearByMonthBarChart() {
      this.bar_chart_year_by_month_loaded = false;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_DASHBOARDS}/operations?depth=true&operation_ata=${this.selected_year}&group_by=operation_ata&chart_type=bar`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);

          this.bar_chart_year_by_month_loaded = true;
          this.bar_year_by_month_chart_data = res.data;
          this.$refs.bar_year_by_month_chart.refresh();
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.bar_chart_year_by_month_loaded = true;
        });
    },
    selectMonthly() {
      this.formated_selected_monthly = moment(this.selected_monthly).format(
        "MM-YYYY"
      );
      // this.formated_selected_monthly_to_display = moment(
      //   this.selected_monthly
      // ).format("MMMM YYYY");
      var date = new Date();
      if (this.selected_monthly.getMonth() < 3) {
        date.setFullYear(this.selected_monthly.getFullYear() - 1);
      } else {
        date = this.selected_monthly;
      }
      this.formated_selected_monthly_to_display = moment(date).format("YYYY");
      this.getOperationMonthPieChart();
    },
    selectMonthly2() {
      this.formated_selected_monthly2 = moment(this.selected_monthly2).format(
        "MM-YYYY"
      );
      // this.formated_selected_monthly_to_display = moment(
      //   this.selected_monthly
      // ).format("MMMM YYYY");
      var date = new Date();
      if (this.selected_monthly2.getMonth() < 3) {
        date.setFullYear(this.selected_monthly2.getFullYear() - 1);
      } else {
        date = this.selected_monthly2;
      }
      this.formated_selected_monthly_to_display2 = moment(date).format("YYYY");
      this.getOperationMonthPieChart2();
    },
  },
  components: {
    Toast,
    InputText,
    Toolbar,
    RadioButton,
    InputNumber,
    Button,
    Dialog,
    Textarea,
    Avatar,
    Tag,
    Dropdown,
    ProgressSpinner,
    InputSwitch,
    Checkbox,
    Chart,
    Card,
    Calendar,
    Chip,
  },
};
</script>
<style scoped>
.input-full-width {
  width: -webkit-fill-available !important;
}
.button-margin-right {
  margin-right: 2px;
}
.input-search-width {
  width: 150px !important;
}
.selected_monthly {
  margin-left: 10px;
}
.selected_year {
  margin-left: 10px;
  width: 200px;
}
.pie-chart-wrapper {
  display: flex;
  align-items: flex-start;
}
.pie-chart-canvas {
  flex: 1;
  min-width: 0;
}
.pie-chart-legend {
  width: 200px;
  min-width: 200px;
  max-height: 480px;
  overflow-y: auto;
  padding-left: 10px;
}
.pie-chart-legend-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.pie-chart-legend-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  cursor: pointer;
  user-select: none;
}
.pie-chart-legend-item:hover {
  opacity: 0.8;
}
.pie-chart-legend-item--hidden .pie-chart-legend-label {
  text-decoration: line-through;
  color: #999;
}
.pie-chart-legend-color {
  display: inline-block;
  width: 14px;
  height: 14px;
  min-width: 14px;
  border-radius: 2px;
  margin-right: 8px;
}
.pie-chart-legend-label {
  font-size: 13px;
  line-height: 1.3;
  word-break: break-word;
}
</style>